import { Button, Grid, Stack, Typography } from "@mui/material";
import { Link } from 'react-router-dom';
import GlassCard from "../../components/dashboard/GlassCard";
import IncidentTimeline from "../../components/enterprise/IncidentTimeline";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { incidentTabs } from "../navigation";
import { platformMockService } from "../../services/mock/platformMockService";
import { useTranslation } from "react-i18next";
import { usePlatform } from "../../context/PlatformContext";

const TimelinePage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.timeline.title")} subtitle={t("platform.pages.timeline.subtitle")} breadcrumbs={[t("platform.nav.incidents"), t("platform.tabs.timeline")]} tabs={incidentTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <Grid container spacing={2.5}>
          <Grid item xs={12} lg={7}>
            <GlassCard hover={false}><IncidentTimeline items={platformMockService.getIncidentTimeline()} /></GlassCard>
          </Grid>
        </Grid>
      ) : (
        <Stack spacing={1.5} alignItems="flex-start">
          <Typography>La linea de tiempo se muestra en el detalle autenticado de cada incidente.</Typography>
          <Button component={Link} to="/incidents/cases" variant="outlined">Abrir bandeja de incidentes</Button>
        </Stack>
      )}
    </ModuleLayout>
  );
};

export default TimelinePage;
